import { jsx as _jsx } from "react/jsx-runtime";
import { useOpeningOrderIncentives } from "@faire/retailer-visitor-shared/stores/domain/useOpeningOrderIncentives";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { chunkTransformations, StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackPricingOpeningOrderIncentivesClickOfferBannerRedirectCtaClick } from "@faire/web-api--source/events/pricing/click/openingOrderIncentivesClickOfferBannerRedirectCta";
import isUndefined from "lodash/isUndefined";
import { observer } from "mobx-react";
import React from "react";
var OpeningOrderIncentivesBannerBase = function() {
    var _useOpeningOrderIncentives = useOpeningOrderIncentives(), openingOrderIncentivesProps = _useOpeningOrderIncentives.openingOrderIncentivesProps, trackOOIBannerViewEvent = _useOpeningOrderIncentives.trackOOIBannerViewEvent;
    React.useEffect(function() {
        trackOOIBannerViewEvent();
    }, [
        trackOOIBannerViewEvent
    ]);
    if (isUndefined(openingOrderIncentivesProps)) {
        return null;
    }
    var endDate = openingOrderIncentivesProps.endDate, discountPercentage = openingOrderIncentivesProps.discountPercentage;
    if (endDate === undefined || discountPercentage === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Typography, {
        "data-test-id": "opening-order-incentives-banner",
        align: "center",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "bGYYNp",
            defaultMessage: [
                {
                    type: 8,
                    value: "MediumFormatting",
                    children: [
                        {
                            type: 0,
                            value: "Enjoy "
                        },
                        {
                            type: 1,
                            value: "discountPercentageNumber"
                        },
                        {
                            type: 0,
                            value: "% off!"
                        }
                    ]
                },
                {
                    type: 0,
                    value: " Try something new and save. Expires "
                },
                {
                    type: 1,
                    value: "endDate"
                },
                {
                    type: 0,
                    value: ". "
                },
                {
                    type: 8,
                    value: "LinkFormatting",
                    children: [
                        {
                            type: 0,
                            value: "View details"
                        }
                    ]
                }
            ],
            values: {
                MediumFormatting: chunkTransformations.Medium,
                discountPercentageNumber: discountPercentage,
                LinkFormatting: LearnMoreLink,
                endDate: endDate
            }
        })
    });
};
export var OpeningOrderIncentivesBanner = observer(OpeningOrderIncentivesBannerBase);
var LearnMoreLink = function(chunks) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: getCurrentPath().append({
            openingOrderIncentives: "1"
        }).toString(),
        "data-test-id": "opening-order-incentives-banner-link",
        onClick: trackPricingOpeningOrderIncentivesClickOfferBannerRedirectCtaClick,
        children: chunks
    });
};
